<template>
  <!-- Settings Dropdown -->
  <div class="ProfileNav relative">
    <jet-dropdown align="right" width="60">
      <template #trigger>
        <button
          v-if="$page.props.jetstream.managesProfilePhotos"
          class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out relative"
        >
          <img
            class="h-8 w-8 rounded-full object-cover"
            :src="$page.props.user.avatar"
            :alt="$page.props.user.name"
          />
          <template v-if="showMenuDot">
            <div class="absolute top-0 left-0 w-gr-4 h-gr-4 -ml-gr-1 rounded-full bg-red-500"></div>
            <div
              class="animate-ping absolute top-0 left-0 w-gr-4 h-gr-4 -ml-gr-1 rounded-full bg-red-500"
            ></div>
          </template>
        </button>

        <span v-else class="inline-flex rounded-md">
          <button
            type="button"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150"
          >
            {{ $page.props.user.name }}

            <svg
              class="ml-2 -mr-0.5 h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </span>
      </template>

      <template #content>
        <profile-nav-links is-dropdown-content />
      </template>
    </jet-dropdown>
  </div>
</template>

<script>
  import JetDropdown from '@/Jetstream/Dropdown';
  import JetDropdownLink from '@/Jetstream/DropdownLink';
  import ProfileNavLinks from '@/Components/ProfileNavLinks';
  import { getTheme, toggleTheme } from '@/Utils/darkmode';

  export default {
    name: 'ProfileNav',

    props: {
      showDashboardLink: {
        type: Boolean,
        default: true,
      },

      showLibraryLink: {
        type: Boolean,
        default: true,
      },

      isFront: {
        type: Boolean,
        default: false,
      },
    },

    components: {
      JetDropdown,
      JetDropdownLink,
      ProfileNavLinks,
    },

    data() {
      return {
        isDark: getTheme() === 'dark',
      };
    },

    computed: {
      hasTeams() {
        return (
          this.$page.props?.user?.teams?.length ||
          Object.keys(this.$page.props?.user?.all_teams || {}).length
        );
      },

      showMyAccountDot() {
        return this.$page.props.canSetPassword && !this.hasTeams;
      },

      showMenuDot() {
        return this.showMyAccountDot;
      },
    },

    methods: {
      toggleTheme() {
        let theme = toggleTheme();
        this.isDark = theme === 'dark';
      },

      logout() {
        this.$inertia.post(route('logout'));
      },

      isLinkActive(route) {
        return route === window.location.origin + window.location.pathname;
      },
    },
  };
</script>

<!-- <style lang="scss" src="./ProfileNav.scss" scoped></style> -->
